export default "__VITE_ASSET__Dmwkyvu2__"